import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ErgonomicsEvaluationReportDialogComponent } from 'app/assessment/evaluation/components/ergonomics-evaluation-report-dialog/ergonomics-evaluation-report-dialog.component';
import { SurveyReportDialogComponent } from 'app/assessment/survey/components/survey-report-dialog/survey-report-dialog.component';
import { SurveyModule } from 'app/assessment/survey/survey.module';
import { AuthService } from 'app/core/authentication/services';
import { MaterialModule } from 'app/material.module';
import { SharedModule } from 'app/shared/shared.module';

import { CreateNewTaskDialogComponent } from './components/create-new-task-dialog/create-new-task-dialog.component';
import { CreateTaskButtonComponent } from './components/create-task-button/create-task-button.component';
import { TaskCardDialogComponent } from './components/task-card-dialog/task-card-dialog.component';
import { TaskCardComponent } from './components/task-card/task-card.component';
import { TasksComponent } from './components/tasks/tasks.component';
import { TaskRestConnectorService, TaskService } from './services';
import { TaskDialogService } from './services/task-dialog.service';
import { TaskEffects, taskReducer } from './state';
import { routedComponents, TaskRoutingModule } from './task-routing.module';

@NgModule({
  imports: [
    StoreModule.forFeature('task', taskReducer),
    EffectsModule.forFeature([
      TaskEffects,
    ]),
    CommonModule,
    ReactiveFormsModule,
    TaskRoutingModule,
    MaterialModule,
    SharedModule,
    SurveyModule,
    TranslateModule,
  ],
  providers: [
    TaskService,
    TaskRestConnectorService,
    TaskEffects,
    TaskDialogService,
    AuthService,
  ],
  declarations: [
    routedComponents,
    TaskCardComponent,
    TaskCardDialogComponent,
    TasksComponent,
    TaskCardComponent,
    TaskCardDialogComponent,
    CreateNewTaskDialogComponent,
    CreateTaskButtonComponent,
  ],
  exports: [
    routedComponents,
    TaskCardComponent,
    TaskCardDialogComponent,
    TasksComponent,
    CreateNewTaskDialogComponent,
    CreateTaskButtonComponent,
  ],
  entryComponents: [
    TaskCardDialogComponent,
    CreateNewTaskDialogComponent,
    ErgonomicsEvaluationReportDialogComponent,
    SurveyReportDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TaskModule { }
